/*
    Character Limit jQuery plugin.
    USAGE: $(yourSelector).charLimit(options)
    OPTIONS:
        charsAllowed - Maximum allowed characters typed
        validationAttribute - Will add this attribute to the element with the value of charsAllowed
        validateRealTime - Will call the parsley validator as you type
    NOTES: If a maxlength attribute is present on the element, that value will be used as the maximum characters
     allowed. If you pass a 'charsAllowed' value on the options object, that value will override the maxlength
      attribute if there was one.
 */

bq.charLimit = function(element, options) {
    this.$element = $(element);
    this.options = options;
    this.$charsRemainingElement = $('<p class="help-block"><span class="char-limit-remaining"></span> ' + bq.messages.global.charactersRemaining + '</p>');
};

bq.charLimit.DEFAULTS = {
    validationAttribute: 'data-validate-maxlength',
    validateRealTime: true
};

bq.charLimit.prototype = {
    init: function(){
        var self = this;

        if(!this.options.charsAllowed && this.$element.is('[maxlength]')){
            this.options.charsAllowed = parseInt(this.$element.attr('maxlength'));
        }

        this.$charsRemainingElement
            .find('.char-limit-remaining')
            .text(this.options.charsAllowed);
        this.$element.attr(this.options.validationAttribute, this.options.charsAllowed);

        if(this.$element.is('[data-validate-maxlength]') || this.$element.is('[maxlength]')){
            this.$element.removeAttr('maxlength'); //This is to allow them to keep typing but show them the negative
            // character number
        }

        this.$element.after(this.$charsRemainingElement);
        this.updateRemaining(this.calculateRemaining(this.$element[0].value.length));

        this.$element.on('keyup input', function(){
            self.updateRemaining(self.calculateRemaining(this.value.length));
            if(typeof $.fn.parsley == 'function') {
                if (self.options.validateRealTime) {
                    self.$element.parsley().validate();
                }
            }
        });
    },
    calculateRemaining: function(numCharsTyped){
        return this.options.charsAllowed - numCharsTyped;
    },
    updateRemaining: function(numCharsRemaining){
      var $commentSubmit = this.$element.parents('.comment-reply-form').find('button');

      if(numCharsRemaining < 0){
            this.$charsRemainingElement
                .css('color', '#d3403a')
                .addClass('text-danger')
                .find('.char-limit-remaining')
                .text(numCharsRemaining)
                .parents('.form-group')
                .addClass('has-error');

            if($commentSubmit.length) {
                $commentSubmit.attr('disabled', 'disabled');
            }
        } else {
            this.$charsRemainingElement
                .css('color', '#999999')
                .removeClass('text-danger')
                .find('.char-limit-remaining')
                .text(numCharsRemaining)
                .parents('.form-group')
                .removeClass('has-error');

            if($commentSubmit.length) {
              $commentSubmit.removeAttr('disabled');
            }
        }
    }
};

// charLimit PLUGIN DEFINITION
// =======================

var charLimitOld = $.fn.charLimit;

$.fn.charLimit = function (options) {
    return this.each(function () {
        var $this   = $(this);
        var data    = $this.data('bq.charLimit');
        var _options = $.extend({}, bq.charLimit.DEFAULTS, $this.data(), typeof(options) === 'object' && options);

        if (!data) { $this.data('bq.charLimit', (data = new bq.charLimit(this, _options))); }
        data.init();
    });
};

$.fn.charLimit.Constructor = bq.charLimit;

// charLimit NO CONFLICT
// =================

$.fn.charLimit.noConflict = function () {
    $.fn.charLimit = charLimitOld;
    return this;
};

// charLimit INIT on Textareas with maxlength
// ==============

bq.charLimitInit = function() {
    /* postponed initialization, content might be loaded over ajax */
    $('body').delegate('textarea[maxlength]', 'focus', function () {
        var el = $(this);
        if (el.data('bq.charLimit')) {
            return;
        }
        el.charLimit(el.data());
    });
};

bq.init.push(bq.charLimitInit);